<template lang="html">
  <div class="window-details-tabs">
    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'info' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'info/undeleted'"></router-link>
      <span>info</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'transaction-history' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'transaction-history/all/all'"></router-link>
      <span>transaction history</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'commission-history' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'commission-history'"></router-link>
      <span>commission history</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'codes' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'codes/all'"></router-link>
      <span>codes</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'user-list' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'user-list/all/all'"></router-link>
      <span>user list</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'bet-history' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'bet-history'"></router-link>
      <span>bet history</span>
    </div>

    <div
      class="window-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'cash-history' }"
    >
      <router-link :to="'/agent/' + $route.params.id + '/' + 'cash-history/all/all'"></router-link>
      <span>cash history</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agent-details-tabs'
}
</script>
